const MAILCHIMP_EMAIL_CAMPAIGN_IDS = {
  REPAIR_TASK_REPORT: {
    70: {
      nl: "",
      en: "",
      fr: "",
    },
    10: {
      nl: "2749b9830e",
      en: "47e2619f59",
      fr: "18fd3bd8b4",
    },
    15: {
      nl: "2749b9830e",
      en: "47e2619f59",
      fr: "18fd3bd8b4",
    },
  },
  EVENT_QUOTE_LINK: {
    70: {
      nl: "",
      en: "",
      fr: "",
    },
    10: {
      nl: "8e92be3a8b",
      en: "ceb28cc9f0",
      fr: "eeb9f7b91a",
    },
  },
  VERIFY_EMAIL: {
    70: {
      nl: "17cb9927e6",
      en: "17cb9927e6",
      fr: "17cb9927e6",
    },
    10: {
      nl: "17cb9927e6",
      en: "17cb9927e6",
      fr: "17cb9927e6",
    },
  },
  FORGOT_PASSWORD: {
    70: {
      nl: "a4b055b505",
      en: "a4b055b505",
      fr: "a4b055b505",
    },
    10: {
      nl: "a4b055b505",
      en: "a4b055b505",
      fr: "a4b055b505",
    },
  },
  REQUEST_QUOTE: {
    70: {
      nl: "a5c2928688",
      en: "58fc3c1e41",
      fr: "7fd3d2a79d",
    },
    10: {
      nl: "4125282679",
      en: "8391c5fc30",
      fr: "2d3d1b7190",
    },
  },
  ORDER_CONFIRMATION: {
    70: {
      nl: "d06171acd2",
      en: "d06171acd2",
      fr: "d06171acd2",
    },
    10: {
      nl: "d06171acd2",
      en: "d06171acd2",
      fr: "d06171acd2",
    },
  },

  PAYMENT_CONFIRMATION: {
    70: {
      nl: "ce46785da3",
      en: "ce46785da3",
      fr: "ce46785da3",
    },
    10: {
      nl: "ce46785da3",
      en: "ce46785da3",
      fr: "ce46785da3",
    },
  },
  CONTACT_US: {
    70: {
      nl: "6bf0a55aae",
      en: "6bf0a55aae",
      fr: "6bf0a55aae",
    },
    10: {
      nl: "6bf0a55aae",
      en: "6bf0a55aae",
      fr: "6bf0a55aae",
    },
  },

  SUBSCRIPTION: {
    70: {
      nl: "eedb970573",
      en: "eedb970573",
      fr: "eedb970573",
    },
    10: {
      nl: "eedb970573",
      en: "eedb970573",
      fr: "eedb970573",
    },
  },
};
const TEST_MAILCHIMP_CONTACT_LIST_ID = "b93e7056a2";
const MAILCHIMP_CONTACT_LIST_ID =
  process.env.REACT_APP_ENV === "production"
    ? {
      70: "e464dd27d6",
      10: "a4bfa0f6c1",
    }
    : {
      70: TEST_MAILCHIMP_CONTACT_LIST_ID,
      10: TEST_MAILCHIMP_CONTACT_LIST_ID,
    };

module.exports = { MAILCHIMP_EMAIL_CAMPAIGN_IDS, MAILCHIMP_CONTACT_LIST_ID };
